import { Provider } from '@angular/core';
import { PORTAL_BASE_URL } from './portal-config.token';
import { environment } from '@env/environment';

export function providePortalBaseUrl(): Provider[] {
  return [
    {
      provide: PORTAL_BASE_URL,
      useValue: environment.portalBaseUrl,
    },
  ];
}
